import React from 'react';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate para redirigir
import '../styles/Tabs.css';

const MobileFixedButtons = () => {
  const navigate = useNavigate(); // Hook para redirigir dentro de la aplicación

  const handleReservaOnline = () => {
    navigate("/reserva"); // Redirige a la ruta /reserva
  };

  const handlePresupuestoCirugia = () => {
    window.location.href = "https://docs.google.com/forms/d/e/1FAIpQLSdhkxxeZGGt8nESj3hH9Yoi_wPFo1qaR-6RA_gSo6Cj2sADAQ/viewform?usp=sharing"; // Enlace al formulario de presupuesto
  };

  return (
    <div className="mobile-fixed-buttons">
      <button className="btn purple" onClick={handleReservaOnline}>
        RESERVA ONLINE
      </button>
      <button className="btn turquoise" onClick={handlePresupuestoCirugia}>
        PRESUPUESTO CIRUGIA
      </button>
    </div>
  );
};

export default MobileFixedButtons;